import { render } from "./infoModal.vue?vue&type=template&id=481dd652&ts=true"
import script from "./infoModal.vue?vue&type=script&lang=ts"
export * from "./infoModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__